// src/components/customers/tabs/tabs-OrderHistory.jsx
import React from "react";
import { useOrdersQuery, useOrderStatusesQuery } from "@queries/order";

export default function OrderHistoryTab({ customer }) {
  const id = customer?.customer_id || customer?.id;
  const { data, isLoading, isError } = useOrdersQuery({ customerId: id }, 1, 1000);
  const { data: statuses = [] } = useOrderStatusesQuery(1);

  const orders = data?.data || [];

  const getStatusName = (statusIdOrName) => {
    if (!statusIdOrName) return "N/A";
    // If it's already a string name (not a number string), return it
    if (isNaN(Number(statusIdOrName))) return statusIdOrName;
    
    const status = statuses.find(s => String(s.order_status_id) === String(statusIdOrName));
    return status ? status.name : statusIdOrName;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    try {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      
      return `${day}/${month}/${year}`;
    } catch (e) {
      return dateStr;
    }
  };

  if (isLoading) return <div className="oc-empty">Loading order history...</div>;
  if (isError) return <div className="oc-empty" style={{ color: "red" }}>Error loading order history</div>;

  return (
    <div className="oc-card">
      <div className="oc-header">
        <h2>Orders History</h2>
      </div>
      <div className="oc-table-wrap">
        <table className="oc-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Order ID</th>
              <th>Order Total</th>
              <th>Order Date</th>
              <th>Order Status</th>
              <th>Order Type</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center", padding: 24 }}>
                  No results!
                </td>
              </tr>
            ) : (
              orders.map((o) => {
                const complementaryReason = o.complemantary_reason ?? o.order?.complemantary_reason ?? "";
                const rowStyle = String(complementaryReason || "").trim()
                  ? { backgroundColor: "#efd9d9" }
                  : undefined;

                return (
                <tr key={o.order_id} style={rowStyle}>
                  <td>{typeof o.customer === 'string' ? o.customer : (o.firstname || customer?.name || "N/A")}</td>
                  <td>
                    <a href={`/orders/${o.order_id}`} target="_blank" rel="noreferrer">
                      {o.order_id}
                    </a>
                  </td>
                  <td>
                    {Number.isFinite(o.order_total)
                      ? Number(o.order_total).toFixed(2)
                      : (o.total ? Number(o.total).toFixed(2) : "0.00")}
                  </td>
                  <td>{formatDate(o.date_added)}</td>
                  <td>{getStatusName(o.order_status_id || o.order_status || o.status)}</td>
                  <td>{o.type || o.order_type || "N/A"}</td>
                </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

